import {
  EcommerceTaxSettingsAction,
  LOAD_ECOMMERCE_TAX_SETTINGS,
  LOAD_ECOMMERCE_TAX_SETTINGS_FAIL,
  LOAD_ECOMMERCE_TAX_SETTINGS_SUCCESS,
  LoadEcommerceTaxSettings,
  LoadEcommerceTaxSettingsFail,
  LoadEcommerceTaxSettingsSuccess,
} from "../actions";

export interface IEcommerceTaxSettingsEntityState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceTaxSettingsState {
  entities: { [websiteId: number]: IEcommerceTaxSettingsEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceTaxSettingsState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceTaxSettingsState = initialState, action: EcommerceTaxSettingsAction): IEcommerceTaxSettingsState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_TAX_SETTINGS:
      payload = (<LoadEcommerceTaxSettings>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_TAX_SETTINGS_SUCCESS:
      payload = (<LoadEcommerceTaxSettingsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_TAX_SETTINGS_FAIL:
      payload = (<LoadEcommerceTaxSettingsFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
